import { IServerContext } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export function getServerContext(serverContext: IServerContext): IServerContext {
  return {
    CurrentCustomer: {
      Id: serverContext.CurrentCustomer?.Id,
    },
    CurrentAccount: {
      Id: serverContext.CurrentAccount?.Id,
      TimeZone: serverContext.CurrentAccount?.TimeZone,
      Name: serverContext.CurrentAccount?.Name,
    },
    CurrentUser: {
      LocaleID: serverContext.CurrentUser?.LocaleID,
      CultureDateTimeFormat: {
        ShortDatePattern: serverContext.CurrentUser?.CultureDateTimeFormat?.ShortDatePattern,
      },
    },
    CurrentAccountInActive: serverContext.CurrentAccountInActive,
    ServicesEndpoints: serverContext.ServicesEndpoints,
    Token: serverContext.Token,
    IsAADUser: serverContext.IsAADUser,
  };
}
